import { isEqual } from 'lodash-es';

const selfParseJson = (obj: Record<string, unknown>) => {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    return obj.toString();
  }
};

export enum InfoCode {
  InitSuccess = 'InitSuccess',
  ChannelWillMount = 'ChannelWillMount',
  ChannelDidMount = 'ChannelDidMount',
  ChanneInitSuccess = 'ChanneInitSuccess',
  DialogChange = 'DialogChange',
  MessagesChange = 'MessagesChange',
  AppWillMount = 'AppWillMount',
  AppDidMount = 'AppDidMount',

  AppDestory = 'AppDestory',
}
export enum ErrorCode {
  InitError = 'InitError',
  AppCtxListenError = 'AppCtxListenError',
  ChannelInitError = 'ChannelInitError',
  ChannelWillMountError = 'ChannelWillMountError',
  ChannelDidMountError = 'ChannelDidMountError',
  ChannelSubEventError = 'ChannelSubEventError',
  MessagesChangeError = 'MessagesChangeError',
  DialogChangeError = 'DialogChangeError',
  AppMountError = 'AppMountError',

  AppDestoryError = 'AppDestoryError',
  MiddleWareError = 'MiddleWareError',
  MiddleWareRsError = 'MiddleWareRsError',

  GetComponentError = 'GetComponentError',
}

export const LOG_LEVEL = {
  FATAL: 'fatal',
  ERROR: 'error',
  WARN: 'warn',
  INFO: 'info',
  DEBUG: 'debug',
  TRACE: 'trace',
};

export type TraceInstance = (params: {
  type: string;
  content: number;
  extra?: { [key: string]: string };
}) => void;

export type LogInstance = (params: {
  type: string;
  info: any;
  level?: string;
  extra?: { [key: string]: string };
}) => void;

export type ErrorReport = (params: {
  type: string;
  info: any;
  extra?: { [key: string]: string };
}) => void;

export interface IConfig {
  traceInstance?: TraceInstance;
  logInstance?: LogInstance;
  errorReport?: ErrorReport;
  extraInfo?: {
    [key: string]: string;
  };
  debug?: boolean;
  nameSpace?: string;
}
/**
 * @description 日志类
 */
export class Logger {
  private logInstance?: LogInstance;
  private errorReport?: ErrorReport;
  private traceInstance?: TraceInstance;
  private debug?: boolean;
  private nameSpace: string;
  private app = Math.random().toString(32).slice(2);
  //返回slardar实例
  get report() {
    return this.logInstance;
  }
  constructor({
    logInstance,
    traceInstance,
    errorReport,
    nameSpace = 'LinkchatCore',
  }: {
    logInstance?: LogInstance;
    errorReport?: ErrorReport;
    traceInstance?: TraceInstance;
    nameSpace?: string;
  }) {
    this.logInstance = logInstance;
    this.traceInstance = traceInstance;
    this.errorReport = errorReport;
    this.nameSpace = nameSpace;
  }

  public setConfig(appConfig?: IConfig) {
    const {
      debug = true,
      logInstance,
      traceInstance,
      errorReport,
      nameSpace = 'LinkchatCore',
    } = appConfig || {};

    (window as any).__CHAT_APP_ID = this.app;
    this.debug = debug;
    this.logInstance = logInstance;
    this.traceInstance = traceInstance;
    this.errorReport = errorReport;
    this.nameSpace = nameSpace;
    return this;
  }

  public error = ({
    title,
    info,
    extra,
  }: {
    title: string;
    info?: any;
    extra?: { [key: string]: string };
  }) => {
    if (this.debug) {
      return this.console({
        info: {
          ...info,
          extra,
        },
        title: title,
      });
    }
    try {
      this.errorReport?.({
        type: this.nameSpace + title,
        info: selfParseJson(info || 'no info content'),
        extra: extra,
      });
    } catch (error) {}
  };

  public info = ({
    level = LOG_LEVEL.INFO,
    info,
    title,
    tag,
    extra,
  }: {
    title: string;
    info?: any;
    level?: string;
    tag?: string;
    extra?: { [key: string]: string };
  }) => {
    if (this.debug) {
      return this.console({
        info: {
          ...info,
          extra,
        },
        title: tag || title,
      });
    }
    try {
      this.logInstance &&
        this.logInstance({
          type: this.nameSpace + title,
          level,
          info: selfParseJson(info || 'no info content'),
          extra: extra,
        });
    } catch (error) {}
  };
  public console({ info, title }: { info: unknown; title: string }) {
    /* tslint:disable */
    console.group(
      '%c%s %c%s',
      'color: red;',
      `[${this.nameSpace}]`,
      'color: violet',
      title,
    );

    if (info) {
      console.info(
        '%c%s %c%s',
        'color: orange',
        typeof info === 'object' ? JSON.stringify(info) : info,
        'color: cyan',
        new Date().toLocaleString(),
      );
    }
    console.groupEnd();
    /* tslint:enable */
  }

  public trace = (
    name: string,
    value: number,
    tag?: { [key: string]: string },
  ) => {
    if (this.debug) {
      return this.console({
        info: {
          ...tag,
        },
        title: name,
      });
    }
    try {
      this.traceInstance &&
        this.traceInstance({
          type: this.nameSpace + name,
          content: value || 1,
          extra: { ...tag },
        });
    } catch (error) {}
  };

  public assert = (a: unknown, b: unknown) => {
    if (!isEqual(a, b)) {
      this.error({
        info: {
          a,
          b,
        },
        title: 'assert error',
      });
    }
  };
}

export const Log = Logger;
export default new Logger({});
